import { render, staticRenderFns } from "./twoFaActivationPopup.vue?vue&type=template&id=5573c122&scoped=true&"
import script from "./twoFaActivationPopup.vue?vue&type=script&lang=js&"
export * from "./twoFaActivationPopup.vue?vue&type=script&lang=js&"
import style0 from "../less/twoFaPopup.less?vue&type=style&index=0&id=5573c122&scoped=true&lang=css&"
import style1 from "./twoFaActivationPopup.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5573c122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5573c122')) {
      api.createRecord('5573c122', component.options)
    } else {
      api.reload('5573c122', component.options)
    }
    module.hot.accept("./twoFaActivationPopup.vue?vue&type=template&id=5573c122&scoped=true&", function () {
      api.rerender('5573c122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/include/twoFaActivationPopup.vue"
export default component.exports